export default __webpack_public_path__ + "static/media/novelties-center-icon.f926eaa2.svg";